import React from 'react';
import GeneralChartsContent from "./general-charts-content.jsx";
import MeasureChartsContent from "./measure-charts-content.jsx";
import DetailsContent from "./details-content.jsx";
import TemporalChartsContent from "./temporal-charts-content.jsx";
import IndividualsContent from "./individuals-content.jsx";

const ReportContent = ({ data, collapsed, boName, hasPermission }) => {
    return (
        <>
            <GeneralChartsContent key={`general-${collapsed}`} data={data} boName={boName} collapsed={collapsed}/>

            <DetailsContent key={`details-${collapsed}`} data={data?.apprehensions_table} boName={boName} hasPermission={hasPermission}/>

            <IndividualsContent key={`individuals-${collapsed}`} data={data?.individuals_info} boName={boName}/>

            <MeasureChartsContent key={`measure-${collapsed}`} data={data?.unit_graphics} boName={boName}/>

            <TemporalChartsContent key={`temporal-${collapsed}`} data={data?.temporal_analisys} boName={boName}/>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;